export { WithImageGalleryVariation as default } from './WithImageGalleryVariation';
